<template>
  <v-dialog v-model="isShowListDialog">
    <v-card class="pb-5">
      <v-layout>
        <v-flex class="text-xs-left"></v-flex>
        <v-flex class="text-xs-center">
          <h2 v-if="isAddLinkPage" class="pa-2">
            {{ lang.select_add_link_page }}
          </h2>
          <h2 v-if="isToLinkPage" class="pa-2">
            {{ lang.select_to_link_page }}
          </h2>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn small flat fab @click="isShowListDialog = false">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <div :class="[$style.listImages, 'px-4']">
        <div
          v-for="(image, index) in images"
          :key="index"
          :class="[
            {
              [$style.listImages__border]: selectedPage === index
            },
            'pa-3',
            $style.listImages__listImageWrapper
          ]"
        >
          <div
            @click="
              isJumpDestinationSelect
                ? emitSetJumpDestinationPage(index)
                : emitGetContentsPageImage(image.dataUrl, index)
            "
            :class="$style.listImages__listImage"
            :style="[
              {
                'background-color': 'white',
                'background-size': 'contain',
                'background-position': 'center',
                'background-image': 'url(' + images[index].dataUrl + ')'
              },
              imageSize
            ]"
          ></div>
          <div class="text-xs-center pt-2">
            <span>{{ displayPageText(index + 1) }}</span>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import defaultCoverImage from "./assets/default_cover_simple.png";

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isBackCoverDefaultSetting: {
      type: Boolean,
      default: false
    },
    isFrontCoverDefaultSetting: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => []
    },
    selectedPage: {
      type: Number,
      default: 0
    },
    isJumpDestinationSelect: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => ({
        page: "ページ",
        select_add_link_page: "リンクを設定するページ",
        select_to_link_page: "リンク先のページ"
      })
    },
    isAddLinkPage: {
      type: Boolean,
      default: false
    },
    isToLinkPage: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      isShowListDialog: false,
      defaultCoverImagePath: defaultCoverImage
    };
  },
  methods: {
    emitGetContentsPageImage(dataUrl, index) {
      this.$emit("getContentsPageImage", dataUrl, index);
    },
    emitUpdateIsShowSelectPageDialog(value) {
      this.$emit("updateIsShowSelectPageDialog", value);
    },
    emitUpdateIsShowSelectJumpPageDialog(value) {
      this.$emit("updateIsShowSelectJumpPageDialog", value);
    },
    emitSetJumpDestinationPage(value) {
      this.$emit("setDestinationPage", value);
    },
    displayPageText(value) {
      return this.lang.page.replace(":page_num", value);
    },
    backgroundImagePath(index) {
      if (this.isFrontCoverDefaultSetting && index === 0) {
        return this.defaultCoverImagePath;
      }

      if (this.isBackCoverDefaultSetting && this.isLastImage(index)) {
        return this.defaultCoverImagePath;
      }

      return this.images[index].dataUrl;
    },
    isLastImage(index) {
      return index + 1 === this.images.length;
    }
  },
  computed: {
    imageSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return { width: "66px", height: "93px" };
        case "md":
          return { width: "108px", height: "152px" };
        default:
          return { width: "118px", height: "172px" };
      }
    }
  },
  watch: {
    isShowDialog() {
      this.isShowListDialog = this.isShowDialog;
    },
    isJumpDestinationSelect() {
      this.isShowListDialog = this.isJumpDestinationSelect;
    },
    isShowListDialog() {
      if (!this.isShowListDialog) {
        this.isJumpDestinationSelect
          ? this.emitUpdateIsShowSelectJumpPageDialog(this.isShowListDialog)
          : this.emitUpdateIsShowSelectPageDialog(this.isShowListDialog);
      }
    }
  }
};
</script>

<style module lang="scss">
.listImages {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  &__border {
    border: 1px solid blue;
  }
  &__listImageWrapper {
    position: relative;
  }
  &__listImage {
    cursor: pointer;
    border: black solid 1px;
  }
  &__disableArea {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 300;
  }
}
</style>
